import videojs from 'video.js';

import './FullWindowToggle.scss';
import { notifyWithFullscreenClose } from '../../utiliti';

class FullWindowToggle extends videojs.getComponent('FullscreenToggle') {
  constructor(player, options) {
    super(player, options);

    player.requestFullscreen = player.enterFullWindow.bind(player);
    player.enterFullScreen = player.enterFullWindow.bind(player);
    player.exitFullscreen = player.exitFullWindow.bind(player);

    player.isFullscreen = () => {
      return !!player.isFullWindow;
    };

    player.on(['enterFullWindow', 'exitFullWindow'], function () {
      player.toggleFullscreenClass_();
      player.trigger('fullscreenchange');
    });
  }

  handleClick() {
    const btn = document.getElementsByClassName('vjs-fullscreen-control')[0];
    if (btn) {
      const title = btn.getAttribute('title');
      if (title === 'Full Screen')
        btn.innerHTML =
          "<img src='minimize.svg'><span class='vjs-control-text' aria-live='polite'>Exit Full screen</span>";
      else
        btn.innerHTML =
          "<img src='maximize.svg'><span class='vjs-control-text' aria-live='polite'>Full Screen</span>";
    }
    if (!localStorage.getItem('window_full_screen')) {
      if (!this.player_.isFullWindow) {
        this.player_.enterFullScreen();
      } else {
        this.player_.exitFullscreen();
      }
    } else {
      if (localStorage.getItem('full_screen_mode')) {
        notifyWithFullscreenClose(this.player_, {
          type: 'EXIT_FULL_SCREEN',
          currentTime: this.player_.currentTime()
        });
        btn.setAttribute('title', 'Full Screen');
        localStorage.removeItem('full_screen_mode');
      } else {
        notifyWithFullscreenClose(this.player_, {
          type: 'GO_FULL_SCREEN',
          currentTime: this.player_.currentTime()
        });
        btn.setAttribute('title', 'Exit Full Screen');
        localStorage.setItem('full_screen_mode', true);
      }
    }
  }

  // Since `FullWindowToggle` are extends from `FullscreenToggle`,
  // disable function will be called if the browser does not support fullscreen API
  // However, `FullWindowToggle` is assumed support in all platform. So the function should be override
  disable(force) {
    force && super.disable();
  }
}

videojs.registerComponent('FullWindowToggle', FullWindowToggle);

const controlBarChildren =
  videojs.getComponent('ControlBar').prototype.options_.children;
const fullScreenButtonIndex = controlBarChildren.indexOf('FullscreenToggle');

controlBarChildren[fullScreenButtonIndex] = 'FullWindowToggle';
